import { Inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { API_ROOT_TOKEN, IS_LOCALHOST_TOKEN } from '../../../injection-tokens';

@Injectable()
export class CraigHttpInterceptor implements HttpInterceptor {
    constructor(
        @Inject(API_ROOT_TOKEN) private readonly apiRoot: string,
        @Inject(IS_LOCALHOST_TOKEN) private readonly isLocalhost: boolean
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let url: string = req.url;

        // For non-localhost environments (dev/prod), replace /api prefix with direct API calls
        if (!this.isLocalhost) {
            url = this.apiRoot + url.replace('/api', '');
        }
        // For localhost, keep /api prefix to use proxy

        const clonedRequest: HttpRequest<any> = req.clone({
            url
        });

        return next.handle(clonedRequest);
    }
}
